import React from 'react';
import PropTypes from 'prop-types';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core';
import { Collapse } from '@mui/material';
import Button from '../../Button';
import RichTextDisplay from '../../RichTextDisplay';

const styles = theme => ({
  root: {
    display: 'flex',
    alignSelf: 'center',
    visibility: 'visible',
    flexGrow: 4,
  },
  wrapper: {
    marginTop: -4,
    flexShrink: 1,
  },
  iconButton: {
    marginTop: 0,
    maxHeight: 24,
    maxWidth: 32,
  },
  alignCenter: {
    alignSelf: 'center',
  },
  alignStart: {
    alignSelf: 'flex-start',
  },
  [theme.breakpoints.down('sm')]: {
    root: {
      marginTop: theme.spacing(1),
    },
    iconButton: {
      alignSelf: 'center',
    },
  },
});

const MAX_HIEGHT_PRE_OVERFLOW = 32;

function ListItemDescription({
  classes, description, expand, setExpand, fileExpand,
}) {
  const overflowRef = React.useRef(null);
  const [hasOverflow, setHasOverflow] = React.useState((overflowRef.current?.clientHeight || 0) > MAX_HIEGHT_PRE_OVERFLOW);

  React.useEffect(() => {
    const { current: node } = overflowRef;
    setHasOverflow(node.clientHeight > MAX_HIEGHT_PRE_OVERFLOW);
  }, [description]);

  return (
    <>
      <Collapse
        className={classNames(classes.root, { [classes.alignStart]: fileExpand || expand })}
        classes={{
          wrapper: classes.wrapper,
        }}
        in={expand}
        timeout={{
          enter: 200,
          exit: 0,
        }}
      >
        <div className={classes.root} style={{ minHeight: 16, width: '100%' }}>
          <RichTextDisplay ref={overflowRef} content={description} />
        </div>
      </Collapse>
      {hasOverflow && (
        <Button
          size="small"
          color="primary"
          onClick={() => setExpand(!expand)}
          variant="icon"
          className={classNames(classes.iconButton, { [classes.alignCenter]: !expand, [classes.alignStart]: expand || fileExpand })}
        >
          {expand ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </Button>
      )}
    </>
  );
}

ListItemDescription.defaultProps = {
  description: '',
};

ListItemDescription.propTypes = {
  fileExpand: PropTypes.bool.isRequired,
  expand: PropTypes.bool.isRequired,
  setExpand: PropTypes.func.isRequired,
  description: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ListItemDescription);
